import { createStore } from "owa-satcheljs";
import type { PersonSourcesState } from "./schema/PersonSourcesState";

export const getStore: () => PersonSourcesState = createStore<PersonSourcesState>("NovaPersonSources", {
    isVisible: false,
    identifiers: {},
    hostAppContext: undefined,
    mailboxInfo: undefined,
    targetWindowId: undefined,
    activePage: undefined,
});
